import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import i18next from 'i18next';
import Social from './Social';
import { Pages } from '../../constants';
import { Link } from 'react-router-dom';
import SmartInvestingNewsletter from '../shared/SmartInvestingNewsletter';

// استيراد الأيقونات الخاصة بمعلومات الاتصال
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import ReportProblemIcon from '@mui/icons-material/ReportProblem'; // أيقونة الشكاوى

const Footer = ({ data }) => {
    let lng = i18next.language;
    const general = data?.general || {};
    const social = data?.social || {};
    const logoUrl = general?.image;
    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    const complaintNumbers = ['0993350007'];

    return (
        <Box
            component="footer"
            sx={{
                position: 'relative',
                width: '100%',
                bgcolor: '#020814',
                color: '#FFFFFF',
                pt: { xs: 6, md: 10 },
                pb: { xs: 6, md: 8 },
            }}
        >
            <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
                {/* Newsletter Section */}
                <Box sx={{ mb: { xs: 10, md: 15 }, mt: { xs: -12, md: -12 } }}>
                    <SmartInvestingNewsletter lng={lng} />
                </Box>

                <Grid container spacing={{ xs: 2, md: 10 }} justifyContent="space-between">
                    {/* Logo and About */}
                    <Grid item xs={12} md={4} lg={3}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Link to="/" onClick={scrollToTop} style={{ textDecoration: 'none' }}>
                                {logoUrl ? (
                                    <Box
                                        component="img"
                                        src={logoUrl}
                                        alt="logo"
                                        sx={{ height: 90, width: 'auto', mb: 4, objectFit: 'contain', filter: "drop-shadow(1px 1px 0 rgba(94,176,255,0.9)) drop-shadow(-1px -1px 0 rgba(94,176,255,0.9)) drop-shadow(1px -1px 0 rgba(94,176,255,0.9)) drop-shadow(-1px 1px 0 rgba(94,176,255,0.9))" }}
                                    />
                                ) : (
                                    <Typography variant="h4" sx={{ color: '#FFFFFF', fontWeight: 800, mb: 4 }}>
                                        ARAM
                                    </Typography>
                                )}
                            </Link>
                            <Typography
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    lineHeight: 1.8,
                                    fontSize: '15px',
                                    mb: 4,
                                    maxWidth: 320,
                                }}
                            >
                                {lng === 'ar'
                                    ? 'نبني منتجات رقمية تساعد الأعمال على النمو والتوسع والنجاح في العالم الرقمي.'
                                    : 'We build digital products that help businesses grow, scale, and succeed in the digital world.'}
                            </Typography>
                            <Social data={social} />
                        </Box>
                    </Grid>

                    {/* Important Links */}
                    <Grid item xs={12} sm={6} md={3} lg={2.5}>
                        <Box>
                            <Typography
                                sx={{
                                    color: '#FFFFFF',
                                    fontWeight: 700,
                                    fontSize: '18px',
                                    mb: 4,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                }}
                            >
                                <Box component="span" sx={{ width: 3, height: 20, bgcolor: '#5EB0FF' }} />
                                {lng === 'ar' ? 'روابط هامة' : 'Important Links'}
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                                {Pages?.map((page, i) => (
                                    <Link
                                        key={i}
                                        to={page.path}
                                        onClick={scrollToTop}
                                        style={{
                                            color: 'rgba(255, 255, 255, 0.7)',
                                            textDecoration: 'none',
                                            fontSize: '16px',
                                            transition: 'all 0.2s',
                                        }}
                                        onMouseEnter={(e) => (e.target.style.color = '#5EB0FF')}
                                        onMouseLeave={(e) => (e.target.style.color = 'rgba(255, 255, 255, 0.7)')}
                                    >
                                        {lng === 'ar' ? page.name : page.name_en}
                                    </Link>
                                ))}
                            </Box>
                        </Box>
                    </Grid>

                    {/* Contact Info */}
                    <Grid item xs={12} sm={6} md={4} lg={3.5}>
                        <Box>
                            <Typography
                                sx={{
                                    color: '#FFFFFF',
                                    fontWeight: 700,
                                    fontSize: '18px',
                                    mb: 4,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                }}
                            >
                                <Box component="span" sx={{ width: 3, height: 20, bgcolor: '#5EB0FF' }} />
                                {lng === 'ar' ? 'مزيد من المعلومات' : "More Information's"}
                            </Typography>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3.5 }}>
                                {general?.address && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <LocationOnIcon sx={{ fontSize: 20, color: '#5EB0FF', opacity: 0.8 }} />
                                        <Typography sx={{ fontSize: '15px', color: 'rgba(255, 255, 255, 0.7)' }}>
                                            {general.address?.[lng] || general.address?.en || general.address}
                                        </Typography>
                                    </Box>
                                )}
                                {general?.phone && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <PhoneIcon sx={{ fontSize: 20, color: '#5EB0FF', opacity: 0.8 }} />
                                        <Typography sx={{ fontSize: '15px', color: 'rgba(255, 255, 255, 0.7)', direction: 'ltr' }}>
                                            {general.phone}
                                        </Typography>
                                    </Box>
                                )}
                                {general?.site_email && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <EmailIcon sx={{ fontSize: 20, color: '#5EB0FF', opacity: 0.8 }} />
                                        <Typography sx={{ fontSize: '15px', color: 'rgba(255, 255, 255, 0.7)' }}>
                                            {general.site_email}
                                        </Typography>
                                    </Box>
                                )}

                                {/* أرقام الشكاوى والدعم الفني */}
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mt: 0.5 }}>
                                    <ReportProblemIcon sx={{ fontSize: 20, color: '#5EB0FF', opacity: 0.8, mt: '2px' }} />
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}>
                                        <Typography sx={{ fontSize: '14px', color: '#5EB0FF', fontWeight: 600 }}>
                                            {lng === 'ar' ? 'أرقام الشكاوى والمقترحات:' : 'Complaints & Support:'}
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                            {complaintNumbers.map((num, idx) => (
                                                <Typography
                                                    key={idx}
                                                    component="a"
                                                    href={`tel:${num}`}
                                                    sx={{
                                                        fontSize: '15px',
                                                        color: 'rgba(255, 255, 255, 0.7)',
                                                        direction: 'ltr',
                                                        textDecoration: 'none',
                                                        width: 'fit-content',
                                                        transition: 'color 0.2s',
                                                        '&:hover': { color: '#5EB0FF' },
                                                    }}
                                                >
                                                    {num}
                                                </Typography>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Footer;